<template>
  <section>
    
    <div id="meet"></div>


    <div class="d-flex">
      <div style="width: 12rem;" class="ml-0 pl-0">
          <h4 class="m-0 p-0 mt-2 mb-1  link-header">{{ $t("FROM") }}</h4>
          {{ FormatDateTime(message.settings.open_from_date) }}
      </div>
      <div style="width: 12rem;" class="ml-0 pl-0">
            <h4 class="m-0 p-0 mt-2 mb-1  link-header">{{ $t("TO") }}</h4>
            {{ FormatDateTime(message.settings.open_to_date) }}
      </div>
    </div>
    

      <hr class="pb-0 mb-0 mt-2" v-if="attachments.length != 0" />

      <div class="mt-2" v-if="attachments.length != 0">
        <span
          v-for="(item, index) in attachments"
          :key="index"
          class="ms-fontSize-12"
        >
          <Attachment :item="item" :index="index"
          :message_uuid="message.message_uuid"
          :user_uuid="user_uuid"
          :functionbox_uuid="functionbox_uuid"></Attachment>
        </span>
      </div>

      <h4 class="m-0 p-0 mt-2 mb-1  link-header">{{ $t("DESCRIPTION") }}</h4>
      
    <BodyText :body="message.external_text"></BodyText>


      <hr class="pb-0 mb-0 mt-2" />

    <div v-if="isFinished">
      <b-button disabled>{{ $t("MEETINGS.EXPIRED") }}</b-button>
    </div>
    <div v-if="!isFinished">
      <b-button variant="primary" class="btn-fill" @click="openMeeting">
        {{ $t("SECURELINK.JITSI.JOIN_MEETING") }}
      </b-button>
    </div>
    <div v-bind:class="{ 'jitsi-meeting': opened }">
      <div id="meet" v-bind:class="{ 'jitsi-meeting': opened }"></div>
    </div>


  </section>
</template>
<script>
import Attachment from "@/components/View/Attachment";
import BodyText from "@/components/View/BodyText";
export default {
  name: "MessageInformation",
  props: ["message","user_uuid", "functionbox_uuid"],
  components: {
    Attachment,
    BodyText
  },
  data() {
    return {
      opened: false
    };
  },
  methods: {
    openMeeting() {
      let self = this;
      this.$http
        .get(this.user.hostname + "/jitsi/join-user/" + this.message.message_uuid)
        .then(function(result) {                    
          let meetingData = result.data;      
          window.open("https://" + meetingData.server + "/" + meetingData.room + "?jwt=" + meetingData.token + "#config.disableDeepLinking=true", '_blank').focus(); 
        })
        .catch(function(error) {
          self.$noty.error(self.$t(error.response));
        });
    }
  },
  computed: {
    isFinished() {
      return this.current > this.expire;
    },
    expire() {
      let date = new Date(this.message.settings.open_to_date);
      return date;
    },
    current() {
      let date = new Date();
      return date;
    },
    attachments() {
      return this.message.attachments;
    },
    addIcs() {
      return this.user.hostname + "/jitsi/ics/" + this.message.message_uuid;
    },
  },
  watch: {},
  mounted: function() {},
};
</script>
<style></style>
